import { jsx as _jsx } from "react/jsx-runtime";
// Tabs: shadcn/ui's Tabs on @radix-ui/react-tabs, restyled as the Companion's canvas tabs
// (mockups/companion.css .cp-tab): quiet labels, the selected one lit with a cyan bar along its top.
// Arrow keys move between tabs (Radix roving focus); Tab leaves the list for the panel. When the list
// is narrower than its labels, each tab shrinks and its label ends in an ellipsis.
import * as TabsPrimitive from "@radix-ui/react-tabs";
import { cva } from "class-variance-authority";
import { cn, focusRing, minTarget } from "./cn.js";
export const Tabs = TabsPrimitive.Root;
export function TabsList({ className, ...props }) {
    return (_jsx(TabsPrimitive.List, { className: cn("flex border-t border-wp-line px-2 font-sans", className), ...props }));
}
const tabsTriggerVariants = cva([
    "group grid flex-auto cursor-pointer justify-items-center rounded-8 border-0 bg-transparent p-0",
    "leading-none font-semibold whitespace-nowrap text-wp-text-3 transition-colors duration-fast ease-wp",
    "hover:text-wp-text-2 data-[state=active]:text-wp-text",
    "disabled:pointer-events-none disabled:opacity-45",
    minTarget,
    focusRing,
    "focus-visible:-outline-offset-5",
], {
    variants: { compact: { false: "h-9.5 text-13", true: "h-8 text-12" } },
    defaultVariants: { compact: false },
});
export function TabsTrigger({ className, compact, children, ...props }) {
    return (_jsx(TabsPrimitive.Trigger, { "data-compact": compact ?? false, className: cn(tabsTriggerVariants({ compact }), className), ...props, children: _jsx("span", { className: cn("relative inline-flex h-full max-w-full min-w-0 items-center", "before:absolute before:inset-x-0 before:-top-px before:h-0.5 before:rounded-b-4 before:bg-wp-accent", "before:scale-x-0 before:transition-transform before:duration-med before:ease-wp", "group-data-[state=active]:before:scale-x-100"), children: _jsx("span", { className: "truncate", children: children }) }) }));
}
export function TabsContent({ className, ...props }) {
    return (_jsx(TabsPrimitive.Content
    // No outline-none here: in Tailwind v4 it sets --tw-outline-style: none, which the ring's
    // outline-2 then reads, and the focusable panel would show no ring at all.
    , { 
        // No outline-none here: in Tailwind v4 it sets --tw-outline-style: none, which the ring's
        // outline-2 then reads, and the focusable panel would show no ring at all.
        className: cn("min-w-0 rounded-8", focusRing, className), ...props }));
}
//# sourceMappingURL=tabs.js.map